import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const OrionAIParent = lazy(() => import("./OrionAIParent"));

const ORIONAI_ROUTES: RouteObject[] = [
  {
    path: "/private/orion-ai",
    element: React.createElement(OrionAIParent),
  },
];

export default ORIONAI_ROUTES;
